module.exports = __webpack_public_path__ + "img/migration-service-activity.84ae7ada.png";